import callAPI from 'api'
import { Filter, ListPayload, ListResponse } from './types/common'
import { FilterItem } from 'components/AdvancedTable/Filters'

export type ItemResponse = {
  quotation_id: string
  reference_number: string
  contract_length: string
  lead_id: string
  lead_name: string
  opportunity_name: string
  opportunity_id: string
  opportunity_owner: string
  approval_status: string
  current_approval_level: number
  max_approval_level: number
  created_by: string
  created_by_name: string
  create_ts: Date
}

export type FilterResponse = Array<FilterItem>

export type GetListPayload = ListPayload<ItemResponse>
export type GetListResponse = ListResponse<ItemResponse, FilterResponse>
export type ListFilter = Filter<ItemResponse>

export const getList = async (payload: GetListPayload) =>
  await callAPI<GetListResponse, GetListPayload>('crm_get_pending_approval_quotation_list', [payload], {
    requireAuthorization: true,
  })
